import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";

import {LOOK_OVERLAYS} from "../../../look/core/constants";
import {setLookAiImageExpanded, setLookAiImageOpened} from "../../aiActions";
import {setLookOverlayOpened, setLookReturnAction} from "../../../../actions/lookFunctions";
import {setUserPopupContent} from "../../../../actions/userFunctions";
import LookAIImageOverlayLoginContent from "./LookAIImageOverlayLoginContent";
import LookAIImageOverlayImageContent from "./LookAIImageOverlayImageContent";
import {IS_QKB_UI} from "../../../../config";


const LookAIImageOverlay = (props) => {

  const {lookOverlayOpened, lookAiImageOpened, lookAiVisited, showLeadOverlay, intl, setLookAiImageOpened, isMobile,
    showImagesListOverlay, setLookOverlayOpened, aiImageExpanded, setLookAiImageExpanded, aiResults} = props;

  if (!lookAiVisited) {
    return null;
  }

  const activeResult = aiResults.find(aiResult => aiResult.isActive);
  const opened = (lookOverlayOpened === LOOK_OVERLAYS.aiPanel) && lookAiImageOpened
    && !(!showLeadOverlay && activeResult && activeResult.conversionError);
  const hideImagesRoll = showLeadOverlay || isMobile || !showImagesListOverlay;

  const closeAIImageOverlay = () => {
    if (aiImageExpanded) {
      setLookOverlayOpened(""); // return sidebar button to be visible
    } else {
      setLookAiImageOpened(false);
      if (IS_QKB_UI && isMobile && showLeadOverlay) {
        setLookOverlayOpened(""); // return sidebar button to be visible
      }
    }
  }

  const expandAIImageOverlay = () => {
    setLookAiImageExpanded(!aiImageExpanded);
  }

  return (
    <div style={{left: (isMobile && showLeadOverlay) || aiImageExpanded
        ? IS_QKB_UI ? "1rem" : isMobile ? "4.5rem" : "5rem"
        : hideImagesRoll
          ? IS_QKB_UI ? "19rem" : isMobile ? "23rem" : "23.5rem"
          : IS_QKB_UI ? "37rem" : "41.5rem"}}
         className={"fixed transition2 look-ai__overlay"
           + (IS_QKB_UI ? " look-ai__overlay--qkb" : "")
           + (!opened ? " opacity-0 visibility-hidden" : "")
           + (isMobile && !IS_QKB_UI ? " u-top-05 u-right-05 u-bottom-05" : " u-top-1 u-right-1 u-bottom-1")}>
      <div className={"bg-white flex flex--column flex--inline u-max-h-full u-p-1 u-rounded-025 z-10"
        + (showLeadOverlay ? " u-w-full u-h-full" : "")
        + (IS_QKB_UI ? " look-icon--with-shadow" : "")}>
        {showLeadOverlay
          ? <LookAIImageOverlayLoginContent/>
          : <LookAIImageOverlayImageContent opened={opened && !showLeadOverlay}
                                            closeAIImageOverlay={closeAIImageOverlay}/>}
        <div className="absolute flex flex--between flex--center u-left-175 u-right-175 u-top-175 z-10">
          <div>
            {showLeadOverlay ? null : (
              <IconButton aria-label={intl.formatMessage({id: "iconButton.more"})}
                          className="look-icon look-icon--small look-icon--white2 u-rounded-full"
                          onClick={expandAIImageOverlay}>
                <AspectRatioIcon className="u-h-125 u-w-125"/>
              </IconButton>
            )}
          </div>
          <div>
            {showLeadOverlay ? (
              <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                          className="look-icon look-icon--small look-icon--white2 u-rounded-full"
                          onClick={closeAIImageOverlay}>
                <CloseIcon/>
              </IconButton>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
};

LookAIImageOverlay.propTypes = {
  showLeadOverlay: PropTypes.bool.isRequired,
  showImagesListOverlay: PropTypes.bool.isRequired,
}

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {lookAiVisited, lookAiImageOpened, aiImageExpanded, aiResults} = store.aiState;
  const {isMobile} = store.serverState;

  return {
    lookOverlayOpened,
    lookAiVisited,
    lookAiImageOpened,
    isMobile,
    aiImageExpanded,
    aiResults,
  };
};

const mapDispatchToProps = {
  setLookAiImageOpened,
  setLookOverlayOpened,
  setLookReturnAction,
  setUserPopupContent,
  setLookAiImageExpanded,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIImageOverlay)
)
